import React, { useRef } from "react";
import {
  Avatar,
  Box,
  Image,
  Input,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  AiOutlineEdit,
  AiOutlinePlus,
  AiOutlineSetting,
} from "react-icons/ai";
import { BsCheckCircle, BsPencil } from "react-icons/bs";
import { IoChatbubbles, IoCheckmark } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import ProfileBox from "./components/ProfileBox";
import { useEffect, useState } from "react";
import http, { AUTH_ROUTES, photoBaseURL } from "../../service/api";
import thelogo from "../..//assets/thelogo.png"
import {
  errorNotifier,
  LoadingMessage,
  shortNotifier,
  successNotifier,
} from "../..";
import { follow, getFollowingUsers, getMyfollowers, unFollow } from "../../pages/dashboard/discover/service";
import { BiImageAdd } from "react-icons/bi";
import UpdatePostImageBackground from "./UpdatePostImageBackground";
import MyGroupCard from "./components/MyGroupCard";
import FollowersModal from "./components/FollowersModal";
import FollowingModal from "./components/FollowingModal";
// import { useGetState } from "../../../context/useGetState";
import { useGetState } from "../../context/useGetState";

// Utility function to format large numbers (e.g., 1000 -> 1K, 1000000 -> 1M)
export function nFormatter(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num;
}

function ProfileOverviewUser(props) {
  let { id } = useParams();

  const [profileInfo, setProfileInfo] = useState({});
  const [posts, setPosts] = useState([]);
  const [isUpdatePost, setIsUpdatePost] = useState(null);
  const { state } = useGetState();
  const userInfo = state?.userInfo;
  
  const [about, setAbout] = useState(
    profileInfo?.about ? profileInfo?.about : "not available"
  );
  const [editAbout, setEditAbout] = useState(false);
  const [editSocialMedia, setEditSocialMedia] = useState(false);

  const [, setBtnLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [isFollowing, setIsFollowing] = useState(profileInfo?.following_status);

  const [followersModalOpen, setFollowersModalOpen] = useState(false);
  const [followingModalOpen, setFollowingModalOpen] = useState(false);
  const [allFollowingUsers, setAllFollowingUsers] = useState([]);
  const [myFollowers, setMyFollowers] = useState([]);
  const [totalFollowers, setTotalFollowers] = useState(0);
  const [totalFollowing, setTotalFollowing] = useState(0);
  const [userGroups, setUserGroups] = useState();
  
  const account_type = "user"; //remove later
  const isLoggedIn = false;

  const imageRef = useRef();
  
  // Effect to fetch profile details based on the user ID or username.
  useEffect(() => {
    const getFullProfileDetails = async () => {
      
      return http.get(AUTH_ROUTES.GET_ANOTHER_USER_PROFILE_DETAILS(id));
      
    };

    getFullProfileDetails()
      .then(({ data }) => {
        setProfileInfo(data);
        setIsFollowing(data?.following_status)
        //console.log('profile:', data);
        
      })
      .catch(() => null);
  }, [id]);

  useEffect(() => {
    const fetchUserGroups = () => {
      // Check if the user is not authenticated
      if (userInfo?.id !== profileInfo?.id) {
        // Filter the 'profileInfo?.groups' to include only 'public' groups
        const publicGroups = profileInfo?.groups.filter((group) => group.group_access === 'public');
        setUserGroups(publicGroups)
        // Now, 'publicGroups' contains only groups with 'group_access' equal to 'public'
        //console.log('Public Groups:', publicGroups);
      } else {
        setUserGroups(profileInfo?.groups)
      }
    }
  
    fetchUserGroups();
  }, [profileInfo]);
  
  

  // Effect to update social media account links based on the fetched profile info.
  useEffect(() => {
    // Updating social media account links based on profile data.
    setPosts(profileInfo?.posts);
    setAbout(profileInfo?.about);
    const socialMedia = profileInfo?.social_media;
    const facebook = socialMedia?.facebook;
    const twitter = socialMedia?.twitter;
    const instagram = socialMedia?.instagram;
    const telegram = socialMedia?.telegram;

    setSocialMediaAccounts((initial) => {
      return initial?.map((data) => {
        if (data?.title?.toLowerCase() === "facebook") {
          return { ...data, link: facebook };
        } else if (data?.title?.toLowerCase() === "twitter") {
          return { ...data, link: twitter };
        } else if (data?.title?.toLowerCase() === "instagram") {
          return { ...data, link: instagram };
        } else if (data?.title?.toLowerCase() === "telegram") {
          return { ...data, link: telegram };
        } else return data;
      });
    });
  }, [profileInfo]);

  console.log("profileInfo:--> ", profileInfo?.id ,state?.userInfo?.id);

  const imgRef1 = useRef();
  const imgRef2 = useRef();
  const imgRef3 = useRef();
  const imgRef4 = useRef();
  const imgRef5 = useRef();
  const imgRef6 = useRef();

  const navigate = useNavigate();

  const textColor1 = useColorModeValue("#2F2F2F", "#FCFCFC");
  const textColor2 = useColorModeValue("#7E838D", "#fff");
  const textColor3 = useColorModeValue("#7E838D", "#fff");
  const textColor4 = useColorModeValue("#656464", "#FCFCFC");
  const textColor5 = useColorModeValue("#302E2E", "#FFF");

  const borderColor = useColorModeValue("#181818", "#707070");

  const btnStyle = {
    p: "5px 10px",
    alignItems: "center",
    borderRadius: "5px",
    color: "#fff",
    direction: "row",
    cursor: "pointer",
  };

  const btnStyle2 = {
    p: "5px 17px",
    alignItems: "center",
    borderRadius: "5px",
    color: "#fff",
    direction: "row",
    cursor: "pointer",
  };

  const updateAboutData = async () => {
    setEditAbout(false);
    props?.setRefresh({});
  };

  const updateCoverImg = async (img) => {
    const formData = new FormData();
    formData.append("cover", img);

    await http.post(AUTH_ROUTES.UPDATE_COVER_IMAGE, formData);

    props?.setRefresh({});
  };

  const [socialMediaAccounts, setSocialMediaAccounts] = useState([
    { title: "Facebook", color: "#0076FF", link: "" },
    { title: "Instagram", color: "#E12784", link: "" },
    { title: "Twitter", color: "#00C2FF", link: "" },
    { title: "Telegram", color: "#009274", link: "" },
  ]);
  
  const updateSocialMediaData = async () => {
    const facebook = socialMediaAccounts?.find(
      (data) => data?.title === "Facebook"
    )?.link;
    const twitter = socialMediaAccounts?.find(
      (data) => data?.title === "Twitter"
    )?.link;
    const instagram = socialMediaAccounts?.find(
      (data) => data?.title === "Instagram"
    )?.link;
    const telegram = socialMediaAccounts?.find(
      (data) => data?.title === "Telegram"
    )?.link;

    const socialMediaLinks = {
      facebook,
      twitter,
      instagram,
      telegram,
    };

    await http.post(AUTH_ROUTES.UPDATE_SOCIAL_MEDIA, socialMediaLinks);

    setEditSocialMedia(false);
    props?.setRefresh({});
  };

  const handleFollowProfileUser = async (userId) => {
    LoadingMessage();

    setBtnLoading(true);
    const formData = new FormData();
    formData.append("user_id", userId);
    if (isFollowing) {
      await unFollow(userId, setBtnLoading)
      setIsFollowing(false)
    } else {
      await follow(userId, setBtnLoading);
      setIsFollowing(true)
    }
  };

  const handleMessageUser = (user) => {
    // if (!isLoggedIn) {
    //   window.location.href = "/";
    //   return;
    // }
    const recipientData = {
      recipient: profileInfo,
      last_message: null,
      unread_messages: []
    }

    const data = [
      recipientData
    ]
    //console.log('formedRecipient: ', data);
   
    localStorage.setItem('privateChatRecipient', JSON.stringify(data))
    // navigate("/messaging11", {
    //   state: { privateChatRecipient: { user } },
    // });
    navigate("/messaging");
    //console.log('another: ', user);
  };

  const handleUpdatePost = async (id, file) => {
    if (!file) return;
    LoadingMessage("Please wait...");
    const formData = new FormData();
    formData.append("file", file);
    formData.append("_method", "PUT");

    await http.post(AUTH_ROUTES.UPDATE_POST(id), formData);
    props?.setRefresh({});
    setRefresh({});
    setIsUpdatePost(null);
  };

  const uploadImg = async (file) => {
    if (!file) return;
    LoadingMessage("Please wait...");
    const formData = new FormData();
    formData.append("file", file);
    await http.post(AUTH_ROUTES.UPLOAD_POST, formData);
    props?.setRefresh({});
    setRefresh({});
  };

  useEffect(() => {
    if (profileInfo?.id) {
      const fetchData = async () => {
        const followingRes = await getFollowingUsers(profileInfo.id);
        setAllFollowingUsers(followingRes?.data?.data);
  
        const followersRes = await getMyfollowers(profileInfo.id);
        setMyFollowers(followersRes?.data?.data);
      };
      setTotalFollowers(profileInfo?.total_followers)
      setTotalFollowing(profileInfo?.total_following)
  
      fetchData();
    }
  }, [profileInfo?.id, totalFollowers, totalFollowing]);

  //follow other users in ProfileUser
  const handleFollow = async (userIdToRemove) => {
    const res = await follow(userIdToRemove, setBtnLoading)
  };

  //unfollow other users in ProfileUser
  const handleUnfollow = async (userIdToRemove) => {
    const res = await unFollow(userIdToRemove, setBtnLoading)
  }

  //console.log('profileInfo: ', profileInfo);

  return (
    <>
      <Stack
        fontSize={".8em"}
        color={"#7E838D"}
        px={["0px", "0px", "0px", "70px"]}
      >
        <ProfileBox position="relative">
          <Box
            m="-15px -40px"
            h="200px"
            mb="10px"
            borderRadius={"6px"}
            bg={
              profileInfo?.cover_picture
                ? `url(${profileInfo?.cover_picture})`
                : "linear-gradient(90deg, rgba(63,94,251,1) 0%, rgba(102,89,221,1) 39%, rgba(118,87,209,1) 56%, rgba(252,70,107,1) 100%)"
            }
          />
          <>
            <Text
              style={{ position: "absolute", right: "50%", top: "20%" }}
              color="#fff"
            >
              {profileInfo?.cover_picture ? null : "1087 x 200"}
            </Text>
          </>

          <Stack direction={["column", "row"]} justifyContent="space-between">
            <Stack mt="-70px">
              <Stack direction={"row"} spacing="30px">
                <Image
                  borderRadius={"50%"}
                  w="100px"
                  maxW="100px"
                  maxH="100px"
                  h="100px"
                  fallbackSrc={thelogo}
                  src={profileInfo?.picture}
                  objectFit="cover"
                  size={"xl"}
                  border="4px solid #fff"
                />
                <Stack direction={"row"} alignItems="center" spacing={"50px"}>
                  <Stack spacing={"-0.5"} alignSelf={"flex-end"} cursor={"pointer"}
                    onClick={() => {
                      if ((profileInfo?.total_followers > 0) && (myFollowers?.length > 0)) {
                        setFollowersModalOpen(true);
                      }
                    }}
                  >
                    <Text
                      fontWeight={"600"}
                      color={textColor5}
                      alignSelf="center"
                    >
                      {nFormatter(profileInfo?.total_followers) || 0}
                    </Text>
                    <Text fontSize={".8em"}>Followers</Text>
                  </Stack>
                  <Stack spacing={"-0.5"} alignSelf={"flex-end"} cursor={"pointer"}
                    onClick={() => {
                      if ((profileInfo?.total_following > 0) && (allFollowingUsers?.length > 0) ) {
                        setFollowingModalOpen(true);
                      }
                    }}
                  >
                    <Text
                      fontWeight={"600"}
                      color={textColor5}
                      alignSelf="center"
                    >
                      {nFormatter(profileInfo?.total_following) || 0}
                    </Text>
                    <Text fontSize={".8em"}>Following</Text>
                  </Stack>
                </Stack>
              </Stack>
              <Stack>
                <Text fontWeight={"400"} color={textColor1} fontSize={"1.2em"}>
                  {profileInfo?.name || ""}
                </Text>
                <Stack color={textColor2} direction="row" alignItems={"center"}>
                  <Text>{`@${profileInfo?.username || ""}`} </Text>
                  <Text>{`${profileInfo?.state || ""}, ${
                    profileInfo?.country || ""
                  }`}</Text>
                </Stack>
              </Stack>
              <Stack maxW="550px" pb="20px">
                <Text fontWeight={"400"} color={textColor1} fontSize={"1.2em"}>
                  About
                </Text>
                {!editAbout ? (
                  <Stack direction={"row"} alignItems="flex-start">
                    <Text maxW="700px" fontSize=".8em">
                      {about}
                    </Text>
                    {props.editable && (
                      <BsPencil
                        cursor={"pointer"}
                        onClick={() => setEditAbout(true)}
                        color="#8E8E8E"
                      />
                    )}
                  </Stack>
                ) : (
                  <Stack direction={"row"} alignItems="flex-start">
                    <Textarea
                      rows={"9"}
                      fontSize=".8em"
                      w="400px"
                      p="0"
                      resize={"none"}
                      bg="transparent"
                      onChange={(e) => setAbout(e.target.value)}
                    >
                      {about}
                    </Textarea>
                    <IoCheckmark
                      cursor={"pointer"}
                      onClick={updateAboutData}
                      color="#8E8E8E"
                    />
                  </Stack>
                )}
              </Stack>
            </Stack>

            <Stack>
              <Stack direction={"row"} justifyContent="space-between" mb="20px">
                <Stack
                  bg="#005FFF"
                  {...btnStyle2}
                  onClick={() => {
                    handleFollowProfileUser(profileInfo?.id);
                  }}
                >
                  <AiOutlinePlus fontSize={"1.5em"} />
                  <Text>{isFollowing ? "Unfolllow" : "Follow"}</Text>
                </Stack>
                <Stack
                  bg="#005FFF"
                  {...btnStyle2}
                  onClick={() => handleMessageUser(profileInfo)}
                >
                  <IoChatbubbles fontSize={"1.5em"} />
                  <Text>Message</Text>
                </Stack>
              </Stack>

              <Stack flex={2}>
                <style>
                  {`
                     .profile-pic:nth-of-type(1) {
                      border-top-left-radius: 10px;
             
                     }
                     .profile-pic:nth-of-type(3) {
                      border-top-right-radius: 10px;
                     }
                     .profile-pic:nth-of-type(4) {
                      border-bottom-left-radius: 10px;
                     }
                      
                     .profile-pic:nth-of-type(6) {
                      border-bottom-right-radius: 10px;
                     }
                      `}
                </style>
                <SimpleGrid columns={3} spacing="10px">

                  {/* photo1 */}
                  <Input
                    type="file"
                    ref={imgRef1}
                    accept="image/jpg, image/jpeg, image/png"
                    display={"none"}
                    // onChange={async (e) => {
                    //   // if (isUpdatePost) {
                    //   //   await handleUpdatePost(
                    //   //     posts?.[0]?.id,
                    //   //     e.target.files?.[0]
                    //   //   );
                    //   //   return;
                    //   // }
                    //   await uploadImg('photo1', e.target.files?.[0]);
                    // }}
                  />
                  {profileInfo?.photo1 ? (
                    <UpdatePostImageBackground
                      isLoggedIn={false}
                      profileInfo={profileInfo}
                      selectedPhotoIndex={1}
                      // onClick={() => {
                      //   setIsUpdatePost(true);
                      //   imgRef1?.current?.click();
                      // }}
                    >
                      <Image
                        w="70px"
                        h="70px"
                        maxW="70px"
                        objectFit={"cover"}
                        className="profile-pic"
                        src={profileInfo.photo1}
                      />
                    </UpdatePostImageBackground>
                  ) : (
                    <Image
                      w="70px"
                      h="70px"
                      maxW="70px"
                      objectFit={"cover"}
                      className="profile-pic"
                      fallbackSrc="https://via.placeholder.com/150"
                    />
                  )}

                  {/* photo2 */}
                  <Input
                    type="file"
                    ref={imgRef2}
                    accept="image/jpg, image/jpeg, image/png"
                    display={"none"}
                    // onChange={async (e) => {
                    //   // if (isUpdatePost) {
                    //   //   await handleUpdatePost(
                    //   //     posts?.[1]?.id,
                    //   //     e.target.files?.[0]
                    //   //   );
                    //   //   return;
                    //   // }
                    //   uploadImg(e.target.files?.[0]);
                    // }}
                  />
                  {profileInfo?.photo2 ? (
                    <UpdatePostImageBackground
                      isLoggedIn={false}
                      profileInfo={profileInfo}
                      selectedPhotoIndex={2}
                      onClick={() => {
                        setIsUpdatePost(true);
                        imgRef2?.current?.click();
                      }}
                    >
                      <Image
                        w="70px"
                        h="70px"
                        maxW="70px"
                        objectFit={"cover"}
                        className="profile-pic"
                        src={profileInfo.photo2}
                      />
                    </UpdatePostImageBackground>
                  ) : (
                    <Image
                      w="70px"
                      h="70px"
                      maxW="70px"
                      objectFit={"cover"}
                      className="profile-pic"
                      fallbackSrc="https://via.placeholder.com/150"
                    />
                  )}

                  {/* photo3 */}
                  <Input
                    type="file"
                    ref={imgRef3}
                    accept="image/jpg, image/jpeg, image/png"
                    display={"none"}
                    // onChange={async (e) => {
                    //   // if (isUpdatePost) {
                    //   //   await handleUpdatePost(
                    //   //     posts?.[2]?.id,
                    //   //     e.target.files?.[0]
                    //   //   );
                    //   //   return;
                    //   // }
                    //   uploadImg(e.target.files?.[0]);
                    // }}
                  />
                  {profileInfo?.photo3 ? (
                    <UpdatePostImageBackground
                      id={id}
                      isLoggedIn={false}
                      profileInfo={profileInfo}
                      selectedPhotoIndex={3}
                      onClick={() => {
                        setIsUpdatePost(true);
                        imgRef3?.current?.click();
                      }}
                    >
                      <Image
                        w="70px"
                        h="70px"
                        maxW="70px"
                        objectFit={"cover"}
                        className="profile-pic"
                        src={profileInfo.photo3}
                      />
                    </UpdatePostImageBackground>
                  ) : (
                    <Image
                      w="70px"
                      h="70px"
                      maxW="70px"
                      objectFit={"cover"}
                      className="profile-pic"
                      fallbackSrc="https://via.placeholder.com/150"
                    />
                  )}

                  {/* photo4 */}
                  <Input
                    type="file"
                    ref={imgRef4}
                    accept="image/jpg, image/jpeg, image/png"
                    display={"none"}
                    // onChange={async (e) => {
                    //   // if (isUpdatePost) {
                    //   //   await handleUpdatePost(
                    //   //     posts?.[3]?.id,
                    //   //     e.target.files?.[0]
                    //   //   );
                    //   //   return;
                    //   // }
                    //   uploadImg(e.target.files?.[0]);
                    // }}
                  />
                  {profileInfo?.photo4 ? (
                    <UpdatePostImageBackground
                      isLoggedIn={false}
                      profileInfo={profileInfo}
                      selectedPhotoIndex={4}
                      onClick={() => {
                        setIsUpdatePost(true);
                        imgRef4?.current?.click();
                      }}
                    >
                      <Image
                        w="70px"
                        h="70px"
                        maxW="70px"
                        objectFit={"cover"}
                        className="profile-pic"
                        src={profileInfo.photo4}
                      />
                    </UpdatePostImageBackground>
                  ) : (
                    <Image
                      w="70px"
                      h="70px"
                      maxW="70px"
                      objectFit={"cover"}
                      className="profile-pic"
                      fallbackSrc="https://via.placeholder.com/150"
                    />
                  )}

                  {/* photo5 */}
                  <Input
                    type="file"
                    ref={imgRef5}
                    accept="image/jpg, image/jpeg, image/png"
                    display={"none"}
                    // onChange={async (e) => {
                    //   // if (isUpdatePost) {
                    //   //   await handleUpdatePost(
                    //   //     posts?.[4]?.id,
                    //   //     e.target.files?.[0]
                    //   //   );
                    //   //   return;
                    //   // }
                    //   uploadImg(e.target.files?.[0]);
                    // }}
                  />
                  {profileInfo?.photo5 ? (
                    <UpdatePostImageBackground
                      isLoggedIn={false}
                      profileInfo={profileInfo}
                      selectedPhotoIndex={4}
                      onClick={() => {
                        setIsUpdatePost(true);
                        imgRef5?.current?.click();
                      }}
                    >
                      {" "}
                      <Image
                        w="70px"
                        h="70px"
                        maxW="70px"
                        objectFit={"cover"}
                        className="profile-pic"
                        src={profileInfo.photo5}
                      />
                    </UpdatePostImageBackground>
                  ) : (
                    <Image
                      w="70px"
                      h="70px"
                      maxW="70px"
                      objectFit={"cover"}
                      className="profile-pic"
                      fallbackSrc="https://via.placeholder.com/150"
                    />
                  )}

                  {/* photo6 */}
                  <Input
                    type="file"
                    ref={imgRef6}
                    accept="image/jpg, image/jpeg, image/png"
                    display={"none"}
                    // onChange={async (e) => {
                    //   // if (isUpdatePost) {
                    //   //   await handleUpdatePost(
                    //   //     posts?.[5]?.id,
                    //   //     e.target.files?.[0]
                    //   //   );
                    //   //   return;
                    //   // }
                    //   uploadImg(e.target.files?.[0]);
                    // }}
                  />
                  {profileInfo?.photo6 ? (
                    <UpdatePostImageBackground
                      isLoggedIn={false}
                      profileInfo={profileInfo}
                      selectedPhotoIndex={6}
                      onClick={() => {
                        setIsUpdatePost(true);
                        imgRef6?.current?.click();
                      }}
                    >
                      <Image
                        w="70px"
                        h="70px"
                        maxW="70px"
                        objectFit={"cover"}
                        src={profileInfo.photo6}
                        fallbackSrc="https://via.placeholder.com/150"
                        className="profile-pic"
                      />
                    </UpdatePostImageBackground>
                  ) : (
                    <Image
                      w="70px"
                      h="70px"
                      maxW="70px"
                      objectFit={"cover"}
                      className="profile-pic"
                      fallbackSrc="https://via.placeholder.com/150"
                    />
                  )}
                </SimpleGrid>
              </Stack>
            </Stack>
          </Stack>
        </ProfileBox>

        <ProfileBox>
          <Stack mb="15px">
            <Text fontWeight={"400"} color={textColor1} fontSize={"1.2em"}>
              Interest
            </Text>
            <Stack direction={"row"} spacing="30px">
              {profileInfo?.interest?.map((data, id) => (
                <Text
                  key={id}
                  color={textColor3}
                  p="5px 10px "
                  border={`1px solid ${borderColor}`}
                >
                  {data}
                </Text>
              ))}
            </Stack>
          </Stack>
          <Stack>
            <Stack direction={"row"} alignItems="center">
              {" "}
              <Text fontWeight={"400"} color={textColor1} fontSize={"1.2em"}>
                Social Media{" "}
              </Text>
              {props.editable &&
                (editSocialMedia === false ? (
                  <BsPencil
                    cursor={"pointer"}
                    onClick={() => setEditSocialMedia(true)}
                    color="#8E8E8E"
                  />
                ) : (
                  <IoCheckmark
                    cursor={"pointer"}
                    onClick={updateSocialMediaData}
                    color="#8E8E8E"
                  />
                ))}
            </Stack>

            <Stack
              direction={"row"}
              flexWrap={["wrap", "nowrap"]}
              spacing="30px"
            >
              {socialMediaAccounts?.map(({ title, color, link }, id) => (
                <Stack key={id}>
                  <Text color={color}>
                    <a href={link} target="_blank">
                      {title}
                    </a>{" "}
                  </Text>
                  {editSocialMedia && (
                    <Input
                      fontSize={".9em"}
                      size="sm"
                      type={"url"}
                      border={`1px solid ${color}`}
                      maxW="100px"
                      value={link}
                      onChange={(e) => {
                        setSocialMediaAccounts((initial) =>
                          initial?.map((data) => {
                            if (data?.title === title) {
                              return { ...data, link: e.target.value };
                            } else return { ...data };
                          })
                        );
                      }}
                    />
                  )}
                </Stack>
              ))}
            </Stack>
          </Stack>
        </ProfileBox>

        <ProfileBox>
          <Stack maxW="300px">
            <Text fontWeight={"400"} color={textColor1} fontSize={"1.2em"}>
              My Groups
            </Text>
            <Stack direction={"columns"} flexWrap="wrap">
              {userGroups?.map((data, id) => (
                
                <MyGroupCard group={data} key={id} authUser={userInfo} profileInfo={profileInfo} />
              ))}
            </Stack>
          </Stack>
          {!props.editable ||
            (!id && (
              <Box
                p="5px 10px"
                cursor={"pointer"}
                borderRadius={"5px"}
                bg="#FF0000"
                color="#fff"
                alignSelf={"flex-end"}
                mr="-30px !important"
                mb="-5px !important"
                display={"none"}
              >
                Report this User
              </Box>
            ))}
        </ProfileBox>

        <FollowersModal
          userId={state?.userInfo?.id}
          authUserId={profileInfo?.id}
          myFollowers={myFollowers}
          handleFollow={handleFollow}
          isOpen={followersModalOpen}
          onClose={() => setFollowersModalOpen(false)}
        />
        <FollowingModal
          userId={state?.userInfo?.id}
          authUserId={profileInfo?.id}
          allFollowingUsers={allFollowingUsers}
          handleUnfollow={handleUnfollow}
          isOpen={followingModalOpen}
          onClose={() => setFollowingModalOpen(false)}
        />
      </Stack>
    </>
  );
}

export default ProfileOverviewUser;
